module.exports = __webpack_public_path__ + "static/media/visa.98d06d52.svg";